import React from 'react'
import { selectMyContractsState, setAddContractDialogState, setConfirmationDialogState } from '../../../../../../features/myContracts/myContractsSlice';
import {useDispatch, useSelector} from 'react-redux'
import AddContract from '../AddContract';
import DeleteContract from './DeleteContract';

const MyContractsActionHandler = (props) => 
{
    const dispatch = useDispatch()
    const myContractsSliceState = useSelector(selectMyContractsState)

    React.useEffect(()=>{
        if(myContractsSliceState.currentAction === 'addContract')
        {
            dispatch(setAddContractDialogState(true))
        }
        else if(myContractsSliceState.currentAction === 'deleteContract')
        {
            dispatch(setConfirmationDialogState(true))
        }
        else if(myContractsSliceState.currentAction === '')
        {
            dispatch(setAddContractDialogState(false))
            dispatch(setConfirmationDialogState(false))    
        }
    },[myContractsSliceState.currentAction])

    return(myContractsSliceState.currentAction === 'addContract' ? <AddContract utilityName={props.utilityName}/> : <DeleteContract utilityName={props.utilityName}/>)
}

export default MyContractsActionHandler